import { StorageKey } from '@/enums';
import axios from 'axios';
import store from '@/store';
import CryptoService from './crypto-services';
import StoragService from './storage-service';
import { StorageKeys, StoreFunctions } from '@/constants';
import * as Sentry from "@sentry/vue";

const cryptoService = new CryptoService();
const gatewayURL = process.env.VUE_APP_GATEWAY_BASE_URL;
const stagingRemoteURL = process.env.VUE_APP_REMOTE_URL;
const EsignRemoteURL = process.env.VUE_APP_ESIGN_RemoteURL;

const ActionListClient_ID = process.env.VUE_APP_ActionListClient_ID;
const ActionListClient_Sceret = process.env.VUE_APP_ActionListClient_Sceret;
const ActionListClient_Audience = process.env.VUE_APP_ActionListClient_Audience;
const EsignClient_Audience = process.env.VUE_APP_EsignClient_Audience;

const storageService = new StoragService();
export default class RequestHelperService {
    defaultUIDefIDKey: string = process.env.VUE_APP_UI_DEF_ID || '';
    defaultCustomerKey: string = process.env.VUE_APP_CUSTOMER_ID || '';
    baseURL = process.env.VUE_APP_GATEWAY_BASE_URL;

    localStorageAgrislicense = {
        username: '',
        password: '',
        beforeEncrptPassword: '',
        agrisLicense: ''
    };

   // private headers = null;
    private headers: any = {};

    async GetAgentSessionId(SessionID = null): Promise<any> {
        var agentInfo = store.getters.getAgentInfo;
        var appName = "ActionList";

        let data: any = await this.GetActivation(agentInfo.AgentEmail, agentInfo.AgentPassword, appName);
        let payload: any;
        if (data && data.MoreInfo) {
            agentInfo.AgentId = data.MoreInfo.AgentId;
            agentInfo.AgentUserName = data.MoreInfo.UserName;
            agentInfo.Password = data.MoreInfo.Password;
            store.commit("setAgentInfo", agentInfo);

            payload = {
                Password: data.MoreInfo.Password,
                Username: data.MoreInfo.UserName,
                DeviceName: "HOPPER",
                SessionID: SessionID,
                CustomerID: "C93F949C-41B8-4C9E-95AA-B030B31F6F3F",
                UIDefID: '45366299-9083-497b-8343-a8f701521358',
                // CustomerID: this.defaultUIDefIDKey,
                // UIDefID: this.defaultCustomerKey,
            };

            let promise = new Promise((resolve: any, reject: any) => {
                axios.post(`${gatewayURL}/culturahub/RESTSecurityWebService/Authenticate`, payload, { headers: { SessionID: SessionID } })
                    .then((response: any) => {
                        let agentInfo = store.getters.getAgentInfo;
                        if (response && response.data) {
                            agentInfo.SessionID = response.data.SessionID;
                            if (agentInfo.SessionID)
                                agentInfo.agentSessionDate = new Date().toLocaleDateString();
                            store.commit(StoreFunctions.setAgentInfo, agentInfo);
                            resolve(agentInfo.SessionID);
                        }
                    }).catch(e => {
                        let agentInfo = store.getters.getUserInfo;
                        resolve(agentInfo.SessionID);
                    });
            });

            return promise;
        }
        return null;
    }

    public getAgrisLicense(userId: any, password: any, beforeEncrptPassword: any, callback: any) {
        let userInfo = store.getters.getUserInfo;
        let tenantId = userInfo.TenantId;
        this.PostCommand(`${gatewayURL}/culturahub/RESTCommandWebService/ExecuteServerCommand/AgrisLicenseProcessor/GetLicense?TenantID=${tenantId}&UserID=${userId}&Password=${encodeURIComponent(password)}&ExtendedOption=nko&ExtendedOptionValue=NAM12`, {});
    }

    async refreshAgrisLicenseCounter(): Promise<boolean> {
        let res: boolean = false;
        let userInfo = store.getters.getUserInfo;

        let refreshLicense = storageService.get(StorageKey.RefreshAgrisLicense);
        console.log("refreshLicense => ", refreshLicense);
        if (refreshLicense === 'true') {
            res = true;
        }

        storageService.set(StorageKey.RefreshAgrisLicense, "true");
        let response: any = await this.refreshAgrisLicense();
        storageService.set(StorageKey.RefreshAgrisLicense, "false");

        if (response == true)
            res = true;


        return res;
        // reject('License count exceeded. To continue using the app, contact your administrator to ensure there are enough licenses available before retrying.');
    }

    getDataFromAgentGateway(url: string, headers: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.get(url, { headers: headers })
                .then((response: any) => {
                    if (response && response.status == 200) {
                        resolve(response.data);
                    }
                    else
                        reject(null);
                }).catch(async e => {
                    if (e.response && e.response.data && e.response.data.Code) {
                        if (e.response.data.Code == 401) {
                            let sessionId = await this.GetAgentSessionId();
                            if (sessionId) {
                                headers.SessionID = sessionId;
                                this.getDataFromAgentGateway(url, headers);
                                resolve(true);
                            }
                            else
                                reject(null);

                        }
                        else if (e.response.data.Code == 404) {
                            resolve([]);
                        }
                    }
                    reject(e);
                });

        })
    }

    postDataToAgentGateway(url: string, payload: any = {}, headers: any) {
        let self = this;
        return new Promise((resolve, reject) => {

            axios.post(url, payload, { headers: headers })
                .then((response: any) => {
                    if (response && response.status == 200) {
                        resolve(response);
                    }
                    else
                        reject(null);
                }).catch(async e => {
                    if (e.response && e.response.data && e.response.data.Code) {
                        if (e.response.data.Code == 401) {
                            let sessionId = await self.GetAgentSessionId();
                            if (sessionId) {
                                headers.SessionID = sessionId;
                                self.postDataToAgentGateway(url, payload, headers);
                                resolve(true);
                            }
                            else
                                reject(null);
                        }
                    }

                    reject(e);
                });

        })
    }


    private async refreshAgrisLicense() {
        let reponse: boolean = false;
        try {
            var agentInfo = store.getters.getAgentInfo;
            var userInfo = store.getters.getUserInfo;

            let tenantId = agentInfo.TenantId;
            this.localStorageAgrislicense = {
                username: userInfo.userEmail,
                password: userInfo.Password,
                beforeEncrptPassword: '6',
                agrisLicense: userInfo.AgrisSessionId
            };

            if (!this.localStorageAgrislicense.username)
                reponse = false;

            let agrisLicense: any = this.localStorageAgrislicense || {};
            let url = `${gatewayURL}/culturahub/RESTCommandWebService/ExecuteServerCommand/AgrisLicenseProcessor/RefreshLicense?TenantID=${tenantId}&UserID=${agrisLicense.username}&Password=${encodeURIComponent(agrisLicense.password)}&ExtendedOption=nko&ExtendedOptionValue=NAM12&AgrisSessionId=${agrisLicense.agrisLicense}`;

            let response: any = await this.PostCommand(url, {});
            if (response && response.Message == "True") {
                let license = {
                    username: agrisLicense.username,
                    password: agrisLicense.password,
                    beforeEncrptPassword: agrisLicense.beforeEncrptPassword,
                    agrisLicense: response.ResultString
                };
                Object.assign(this.localStorageAgrislicense, license);
                let userInfo = store.getters.getAgentInfo;
                userInfo.AgrisSessionId = this.localStorageAgrislicense.agrisLicense;
                store.commit(StoreFunctions.SetUserInfo, userInfo);
                reponse = true;
            }
        } catch (ex) {
            reponse = false;
            console.log(ex);
        }

        return reponse;

    }

    PostCommand(remoteURL: string, payload: any, headers: any = null): Promise<any> {
        if (payload) {
            var agentInfo = store.getters.getAgentInfo;
            var userInfo = store.getters.getUserInfo;

            payload.User = userInfo.userEmail;
            payload.Password = userInfo.Password;
            payload.AgrisSession = userInfo.AgrisSessionId;
            payload.SessionId = agentInfo.SessionID;
            payload.TenantId = agentInfo.TenantId;

            headers = {
                SessionID: payload.SessionId,
            }
        } else {
            payload = { "CustomerID": "C93F949C-41B8-4C9E-95AA-B030B31F6F3F" }
        }
        return new Promise((resolve, reject) => {
            axios.post(`${remoteURL}`, payload, { headers: headers }).then(
                (response: any) => {
                    resolve(response.data);
                }).catch(e => {
                    reject(e);
                })
        });
    }
    async GetActivation(clientEmail: string, clientPassword: string, appName: string): Promise<any> {
        clientPassword = encodeURIComponent(clientPassword);
        // clientPassword = "Z%2BN26gMMUJQ3LJYaCWc9Pg%3D%3D";
        let adminSessionId = await this.GetAdminSessionId();
        if (adminSessionId) {
            try {
                let url = `${gatewayURL}/culturahub/RESTCommandWebService/ExecuteServerCommand/ActivationsCommandProcessor/ActivateApp?AgentEmail=${clientEmail}&AgentPassword=${clientPassword}&AppName=${appName}&AppVersion=1.0.0`;
                let response: any = await this.PostCommand(url, null, { SessionID: adminSessionId });
                if (response) {
                    return response;
                }
            } catch (e) {
                return e;
            }
        }
        return null;
    }
    GetAdminSessionId(): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            let remoteURL = `${gatewayURL}/culturahub/RESTSecurityWebService/Authenticate`;
            
            axios.post(remoteURL, {
                Password: "TLJUFZIZQPB+u9y1mPfmSw==",
                Username: "apiAdmin",
                DeviceName: "HOPPER",
                UIDefID: this.defaultUIDefIDKey,
                CustomerID: this.defaultCustomerKey,
                SessionID: null
            }, { headers: this.headers }
            ).then(
                (response: any) => {
                    resolve(response.data.SessionID);
                }).catch(e => {
                    reject(e);
                })
        });
        return promise;
    }


    async Get(remoteUrl: string, _body: any, customerKey: any, SessionID: any, TenantID: any, SelectedEntities: any, Options: any, uiDefId: any, isHttp = false, islogOff = false, isQuniqueUrl = false, isAuthCall = false): Promise<any> {

        let promise = new Promise(async (resolve, reject) => {
            let headers = ({});
            let store:any = localStorage.getItem("store");
            let agentType = JSON.parse(store).AgentType;
            if (customerKey) Object.assign(headers, { "CustomerID": customerKey });
            if (SessionID) Object.assign(headers, { "SessionID": SessionID });
            if (TenantID) Object.assign(headers, { "TenantID": TenantID });
            if (SelectedEntities) Object.assign(headers, { "SelectedEntities": SelectedEntities });
            if (Options) Object.assign(headers, { "Options": Options });
            Object.assign(headers, { "AgentType": agentType });

            let protocol = "";
            if (remoteUrl.indexOf('http://') === 0 || remoteUrl.indexOf('https://') === 0) {

            } else {
                protocol = isHttp || remoteUrl.indexOf('localhost') === 0 ? 'http://' : 'https://';
            }

            let url = protocol + remoteUrl;
            if (isQuniqueUrl) {
                url = this.addUniqueQueryParam(url);
            }

            if ((url.includes(`${stagingRemoteURL}`) || url.includes(`${EsignRemoteURL}`)) && !isAuthCall) {
                let auth0;
                url = url.replace(/(api\/)([^/]+)/, (match, p1, p2) => `${p1}${p2}V2`);
                auth0 =await this.GetAuthTokenFormLocal(url,SessionID);

                if (auth0) {
                    var headerAuthorization = 'Bearer ' + cryptoService.dencryptString(auth0).toString();
                 //   console.log(headerAuthorization);
                    Object.assign(headers, { "Authorization": headerAuthorization });
                }
            }

            try {

                await axios.get(url, { headers: headers })
                    .then((response: any) => {
                        if (response && response.status == 200) {
                            resolve(response);
                        }
                        else
                            reject(null);
                    }).catch(e => {
                        reject(e);
                    });

            } catch (error) {
                reject(error);
            }
        });
        return promise;
    }

    async Post(remoteUrl: string, _body: any, customerKey: any, SessionID: any, TenantID: any, SelectedEntities: any, Options: any, uiDefId: any, isHttp = false, islogOff = false, isQuniqueUrl = false, isAuthCall = false,headers:any={}): Promise<any> {
        let promise = new Promise(async (resolve, reject) => {
           // var headers: any;

            if (customerKey) Object.assign(headers, { "CustomerID": customerKey });
            if (SessionID) Object.assign(headers, { "SessionID": SessionID });
            if (TenantID) Object.assign(headers, { "TenantID": TenantID });
            if (SelectedEntities) Object.assign(headers, { "SelectedEntities": SelectedEntities });
            if (Options) Object.assign(headers, { "Options": Options });

            let initialBody = {
                CustomerID: customerKey,
                SessionID: SessionID,
                UIDefID: uiDefId,
            };

            let body = SessionID || customerKey || uiDefId ? { ...initialBody, ..._body } : {};
            if (islogOff) {
                headers["SessionID"] = SessionID;
                body = null;
            }

            let protocol = "";
            if (remoteUrl.indexOf('http://') === 0 || remoteUrl.indexOf('https://') === 0) {

            } else {
                protocol = isHttp || remoteUrl.indexOf('localhost') === 0 ? 'http://' : 'https://';
            }

            if (remoteUrl.indexOf("WarehouseDeliveryLocation/InsertUpdateDeliveryLocation")) {
                body = _body;
            }

            let url = protocol + remoteUrl;
            if (isQuniqueUrl) {
                url = this.addUniqueQueryParam(url);
            }

            if ((url.includes(`${stagingRemoteURL}`) || url.includes(`${EsignRemoteURL}`)) && !isAuthCall) {
                let auth0;
                url = url.replace(/(api\/)([^/]+)/, (match, p1, p2) => `${p1}${p2}V2`);
                auth0 =await this.GetAuthTokenFormLocal(url,SessionID);

                if (auth0) {
                    var headerAuthorization = 'Bearer ' + cryptoService.dencryptString(auth0).toString();
                   // console.log(headerAuthorization);
                    Object.assign(headers, { "Authorization": headerAuthorization });
                }
            }

            try {
                const signal = Options && Options.signal ? Options.signal : null; // Extract the signal from Options if available
                await axios.post(url, body, { headers: headers, signal: signal })
                    .then((response: any) => {
                        resolve(response);
                    })
                    .catch(e => {
                        reject(e);
                    })

            } catch (error) {
                reject(error);
            }
        });
        return promise;
    }


    async GetAuthToken(remoteUrl: any, Audience:any): Promise<any> {
        return new Promise(async (resolve, reject) => {
            var agentInfo = store.getters.getAgentInfo;
            var userInfo = store.getters.getUserInfo;

            let tenantId;
            let SessionID;
            if (agentInfo) {                
                tenantId = agentInfo.TenantId;
                SessionID = agentInfo.SessionID;
            }
            let agentId = agentInfo.AgentId;
            let username;

            if (userInfo) {
                username = userInfo.userEmail;
            }
            let request: any = {
                tenantId: tenantId,
                agentId: agentId,
                sessionId: SessionID,
                userId: username,
                clientId: `${ActionListClient_ID}`,
                ClientSecretKey:`${ActionListClient_Sceret}`,
                ClientAudience:Audience

            };
            let body = {
                EncryptedData: cryptoService.encryptString(JSON.stringify(request))
            }
            const parsedUrl = new URL(`${stagingRemoteURL}`); // Parse the URL
            
            let actionListRemote = parsedUrl.hostname; // Extract the hostname
            let url = `${actionListRemote}/actionlistreview/api/Auth/GetAuthToken`;
            try {

                this.Post(url, body, undefined, SessionID,tenantId,undefined,undefined,undefined, false, false, false, true).then(response => {
                    if (response && response.data.TransactionObject) {
                        if (Audience == `${ActionListClient_Audience}`){
                            store.commit("setTokenForActionListApis", JSON.stringify(response.data.TransactionObject[0]))
                        }else {
                            store.commit("setTokenForEsignApis", JSON.stringify(response.data.TransactionObject[0]))
                        }

                       
                        resolve(response.data.TransactionObject[0].Token);
                    } else {
                        reject(response.ErrorMessage)
                    }
                });
            } catch (e: any) {
                let message = `Error-in-GetAuthToken => ${e.message}`;
                console.log(message);
            }
        });
    }

    private addUniqueQueryParam(url: string): string {
        const uniqueParam = `cacheBuster=${new Date().getTime()}`;
        return url.includes('?') ? `${url}&${uniqueParam}` : `${url}?${uniqueParam}`;
    }

    private async GetAuthTokenFormLocal(url: string, SessionID: any): Promise<string> {
       // debugger ;
        let auth0 = null;
        let authexpiry = null;
        let token = null;
        let Audience = null;
        if (url.includes(`${stagingRemoteURL}`)) {
            token = store.getters.getTokenForActionListApis;
            Audience = `${ActionListClient_Audience}`;
        }
        else if (url.includes(`${EsignRemoteURL}`)) {
            token = store.getters.getTokenForEsignApis;
            Audience = `${EsignClient_Audience}`;
        }

        if (token) {
            const parsedToken = JSON.parse(token);
            auth0 = parsedToken.Token;
            authexpiry = parsedToken.Expire; // Assuming `Expire` is in Unix timestamp format (milliseconds)
        }

        const date = new Date(authexpiry);
        const millisecondsAuthexpiry = date.getTime();
        const currentUtcTime = new Date().getTime(); // Current UTC time in milliseconds
        const authexpiryUtc = millisecondsAuthexpiry || 0;

        if (!auth0 || authexpiryUtc < currentUtcTime) {
            auth0 = await this.GetAuthToken(url,Audience);
        }
        return auth0;
    }

}
